import { SortedCatalog } from "../components/SortedCatalog";
import { toolDefinitions } from "./toolDefinitions";
import { ToolItem } from "./ToolItem";

export function ToolCatalog({ limit }: { limit?: number }) {
  return (
    <SortedCatalog
      items={toolDefinitions}
      label="Sort tools"
      defaultOrder="title-asc"
      limit={limit}
      compact
      renderItem={(item) => (
        <ToolItem key={item.name} tool={item} to={`/tools/${item.name}`} />
      )}
    />
  );
}
